import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentMachineService {

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http
    .get(`${environment.url}/payment_machines`).pipe(map((res: any) => res['hydra:member'])) as Observable<any[]>;
  }

  post(req: any) {
    return this.http.post(
      `${environment.url}/payment_machines`,
      req
    ) as Observable<any>;
  }

  delete(id: number) {
    return this.http.delete(
      `${environment.url}/payment_machines/${id}`
    ) as Observable<any>;
  }

  edit(req: any , id: any) {
    return this.http.put(
      `${environment.url}/payment_machines/${id}`,
      req
    ) as Observable<any>;
  }

  getCalculateFees(paymentMethodId: string, amount: number, installments: number | null = null) {
    return this.http.post(`${environment.url}/calculate_fees`, {
      paymentMethod: paymentMethodId,
      installments: installments,
      baseAmount: amount
    }) as Observable<any[]>;
  }

}
